import { Link } from "react-router-dom";
import EN from "@/constants/en";

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-primary text-white py-8">
            <div className="container-custom">
                <div className="flex flex-col md:flex-row justify-between items-center">
                    <div className="mb-4 md:mb-0">
                        <h3 className="text-xl font-semibold">{EN.SITE_TITLE}</h3>
                        <p className="text-sm text-white/80">{EN.FOOTER_TAGLINE}</p>
                    </div>

                    <div className="flex flex-wrap justify-center gap-x-4 gap-y-3">
                        <a href="#about" className="hover:text-accent/90 transition-colors text-sm min-h-[48px] min-w-[48px] flex items-center justify-center px-3 py-2">
                            {EN.NAV_ABOUT}
                        </a>
                        <a href="#experience" className="hover:text-accent/90 transition-colors text-sm min-h-[48px] min-w-[48px] flex items-center justify-center px-3 py-2">
                            {EN.NAV_EXPERIENCE}
                        </a>
                        <a href="#skills" className="hover:text-accent/90 transition-colors text-sm min-h-[48px] min-w-[48px] flex items-center justify-center px-3 py-2">
                            {EN.NAV_SKILLS}
                        </a>
                        <Link to="/ai" className="hover:text-accent/90 transition-colors text-sm min-h-[48px] min-w-[48px] flex items-center justify-center px-3 py-2">
                            AI Systems
                        </Link>
                        <a href="#projects" className="hover:text-accent/90 transition-colors text-sm min-h-[48px] min-w-[48px] flex items-center justify-center px-3 py-2">
                            {EN.NAV_PROJECTS}
                        </a>
                        <a href="#education" className="hover:text-accent/90 transition-colors text-sm min-h-[48px] min-w-[48px] flex items-center justify-center px-3 py-2">
                            {EN.NAV_EDUCATION}
                        </a>
                        <a href="#contact" className="hover:text-accent/90 transition-colors text-sm min-h-[48px] min-w-[48px] flex items-center justify-center px-3 py-2">
                            {EN.NAV_CONTACT}
                        </a>
                    </div>
                </div>

                <div className="mt-8 pt-4 border-t border-white/20 text-center text-sm text-white/70">
                    <p>
                        © {currentYear} {EN.SITE_TITLE}. {EN.FOOTER_RIGHTS}
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
